import { useState, useEffect } from "react";
import { useI18n } from "@/i18n/I18nContext";

function diff(target) {
  const total = new Date(target).getTime() - Date.now();
  const clamp = Math.max(total, 0);
  return {
    total: clamp,
    jours: Math.floor(clamp / 86400000),
    heures: Math.floor((clamp / 3600000) % 24),
    minutes: Math.floor((clamp / 60000) % 60),
    secondes: Math.floor((clamp / 1000) % 60),
  };
}

const Unit = ({ value, label, testKey }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-unit-${testKey}`}>
    <span className="font-serif text-4xl sm:text-5xl md:text-6xl text-white text-glow-gold tabular-nums">
      {String(value).padStart(2, "0")}
    </span>
    <span className="mt-2 font-mono text-[10px] sm:text-xs tracking-[0.25em] uppercase text-theatre-gold/80">
      {label}
    </span>
  </div>
);

export const Countdown = ({ target, testId }) => {
  const { t } = useI18n();
  const [c, setC] = useState(() => diff(target));

  useEffect(() => {
    const id = setInterval(() => setC(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (c.total <= 0) {
    return (
      <div data-testid={testId} className="text-theatre-gold font-serif text-2xl">
        {t("cd.echeance")}
      </div>
    );
  }

  return (
    <div data-testid={testId} className="flex items-start gap-4 sm:gap-8" dir="ltr">
      <Unit value={c.jours} label={t("cd.jours")} testKey="jours" />
      <span className="font-serif text-4xl sm:text-6xl text-theatre-gold/30">:</span>
      <Unit value={c.heures} label={t("cd.heures")} testKey="heures" />
      <span className="font-serif text-4xl sm:text-6xl text-theatre-gold/30">:</span>
      <Unit value={c.minutes} label={t("cd.minutes")} testKey="minutes" />
      <span className="font-serif text-4xl sm:text-6xl text-theatre-gold/30">:</span>
      <Unit value={c.secondes} label={t("cd.secondes")} testKey="secondes" />
    </div>
  );
};
